/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { connect } from "react-redux";
import {
    Grid,
    useTheme,
    Select,
    MenuItem,
    CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';
import { useTranslation } from "react-i18next";
import { LANGUAGES } from '../../config/config';

const AuthenticationLayoutUkoHalfBeMyself = (props) => {
    const {
        children,
        title,
        logoSignIn,
        backgroundLogin,
        qrLogo,
        handleGenerateQr,
        versionMessage,
        paramsCiamConnect,
        tenant,
        tenantDisplay,
    } = props;

    const [isPressImage, setIsPressImage] = useState(false);
    const theme = useTheme();
    const classes = useStyles();
    const [t, i18n] = useTranslation("global");

    const onChangeLang = (e) => {
        const lang_code = e.target.value;
        setTimeout(() => {
            i18n.changeLanguage(lang_code);
        }, 2000);
        localStorage.setItem('bms_lang', JSON.stringify(lang_code));
        sessionStorage.removeItem('versionApp');
        window.location.reload();
    };

    const getFlagSrc = (lang) => {
        return LANGUAGES.filter((arr) => arr.code === lang)[0];
    };

    const handlePressImage = () => {
        setIsPressImage(true);
        handleGenerateQr();
    };

    const setTraductionsText = (traductionsName, tag, value) => {
        const textLanguage = t(traductionsName).replace( `{${tag}}`, value)
        return textLanguage;
    };

    return (
        <Grid container style={{ minHeight: "100vh" }} >
            <Grid item md={6} xs={12} className={classes.gridOrderFirst} >
                <Box
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: "100%",
                        backgroundImage: `url(${backgroundLogin})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                    sx={{
                        padding: 4,
                        height: "100%",
                    }}>
                    <Box style={{ zIndex: 1, width: '60%', marginTop: '23px', marginBottom: '23px' }}>
                        <img src={logoSignIn} alt="Logo" style={{ width: theme.widthImageLogo }} />
                        <h1 style={{ fontWeight: "700", fontStyle: 'normal', fontSize: "34px", marginTop: "70px", color: theme.palette.secondary.titleText }}>
                            {title}
                        </h1>
                        <h1 style={{ fontWeight: "700", fontStyle: 'normal', fontSize: "26px", marginTop: "20px", color: theme.palette.secondary.titleText }}>
                            {t("auth-qr.label-income")}
                        </h1>
                        <h1 style={{ fontWeight: "500", fontStyle: 'normal', fontSize: "18px", marginTop: "20px", color: theme.palette.secondary.titleText }}>
                            {setTraductionsText(t("auth-qr.label-smart-credential.first"), 'appNameTenant', tenantDisplay)} <br />
                            {setTraductionsText(t("auth-qr.label-smart-credential.second"), 'appNameTenant', tenantDisplay)}
                        </h1>
                        <div style={{ paddingLeft: '10px' }}>
                            <h1
                                style={{ fontWeight: "400", fontStyle: 'normal', fontSize: "16px", marginTop: "20px", color: theme.palette.secondary.titleText }}                                
                                dangerouslySetInnerHTML={{ __html: setTraductionsText('auth-qr.label-open-app', 'appNameTenant', tenantDisplay) }}
                            />
                            <h1 style={{ fontWeight: "400", fontStyle: 'normal', fontSize: "16px", color: theme.palette.secondary.titleText }}>
                                • {t("auth-qr.activate-reader")}
                            </h1>
                            <h1 style={{ fontWeight: "400", fontStyle: 'normal', fontSize: "16px", color: theme.palette.secondary.titleText }}>
                                • {t("auth-qr.label-generate")}
                            </h1>
                            <h1 style={{ fontWeight: "400", fontStyle: 'normal', fontSize: "16px", color: theme.palette.secondary.titleText }}>
                                • {t("auth-qr.label-select")}
                            </h1>
                            <h1 style={{ fontWeight: "400", fontStyle: 'normal', fontSize: "16px", color: theme.palette.secondary.titleText }}>
                                • <span style={{ fontWeight: 'bold' }}>{t("auth-qr.label-and-ready")}</span>
                            </h1>
                            <br />
                            {
                                paramsCiamConnect && !isPressImage ? (
                                    <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <div style={{ position: 'relative', textAlign: 'center', cursor: 'pointer' }} onClick={handlePressImage}>
                                            <img
                                                src={qrLogo}
                                                alt="Logo"
                                                style={{ width: '222px', height: '222px' }}
                                            />
                                            <div style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                textAlign: 'center',
                                                width: '100%',
                                            }}>
                                                <div style={{
                                                    color: '#141D1E',
                                                    fontSize: '21px',
                                                    fontWeight: '600',
                                                    lineHeight: '23px',
                                                    textDecoration: 'underline',
                                                }}>
                                                    {t("auth-qr.text-in-background.first")}
                                                </div>
                                                <div style={{
                                                    color: '#141D1E',
                                                    fontSize: '21px',
                                                    fontWeight: '600',
                                                    lineHeight: '19px',
                                                    textDecoration: 'underline',
                                                }}>
                                                    {t("auth-qr.text-in-background.second")}
                                                </div>
                                            </div>
                                        </div>
                                    </Box>
                                ) : (
                                    <Box style={{ textAlign: 'center' }}>
                                        <CircularProgress size={50} color="secondary" />
                                    </Box>
                                )
                            }
                        </div>
                    </Box>
                </Box>
            </Grid>
            <Grid item md={6} xs={12} className={classes.gridOrderData} style={{ background: theme.palette.secondary.light, display: "flex", justifyContent: "center" }}>
                <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", height: "100%", width: "100%" }}>
                    <Box style={{ width: '92%', display: 'flex', justifyContent: 'flex-end', padding: '16px' }}>
                        <Select
                            className={classes.root}
                            classes={{ select: classes.select }}
                            value={i18n.language}
                            onChange={onChangeLang}
                            renderValue={(selected) => {
                                const flagSrc = getFlagSrc(selected);
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', paddingRight: '32px' }}>
                                        <img src={flagSrc?.img} alt="language" style={{ width: '28px', height: '28px' }} />
                                        <p style={{ margin: 0, lineHeight: 'normal', color: '#EDEDED', fontSize: '14px', marginTop: '4px' }}>{flagSrc?.code.toUpperCase()}</p>
                                    </div>
                                );
                            }}
                            MenuProps={{
                                PaperProps: {
                                    className: classes.menuPaper,
                                },
                            }}
                        >
                            {LANGUAGES.map(({ code, label, img }) => (
                                <MenuItem
                                    className={classes.menuItem}
                                    key={code}
                                    value={code}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                        <img
                                            src={img}
                                            alt="language"
                                            style={{ width: '24px', height: 'auto', marginLeft: '8px' }}
                                        />
                                        <span style={{ lineHeight: 'normal', marginTop: '4px' }}>{code.toUpperCase()} - {label}</span>
                                    </div>
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                    <Box style={{ textAlign: "center", maxWidth: "550px", width: "100%", padding: "32px", flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <h1 style={{ textAlign: "start", fontWeight: "700", fontStyle: 'normal', fontSize: "28px", marginTop: "20px", color: theme.palette.secondary.titleText, marginBottom: 0 }}>
                            {t("administrator-mode.title")}
                        </h1>
                        <h1 style={{ textAlign: "start", fontWeight: "600", fontStyle: 'normal', fontSize: "17px", marginTop: "20px", color: theme.palette.secondary.titleText, marginBottom: 0 }}>
                            {t("administrator-mode.description.first")}
                        </h1>
                        <h1 style={{ textAlign: "start", fontWeight: "600", fontStyle: 'normal', fontSize: "17px", color: theme.palette.secondary.titleText }}>
                            {t("administrator-mode.description.second")}
                        </h1>
                        <h1 style={{ textAlign: "start", fontWeight: "600", fontStyle: 'normal', fontSize: "19px", marginTop: "20px", color: theme.palette.secondary.titleText, marginBottom: 0 }}>
                            {t("administrator-mode.description.third")}
                        </h1>
                        {children}
                    </Box>
                    <Box className={classes.version}>
                        <p>{versionMessage}</p>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

AuthenticationLayoutUkoHalfBeMyself.propTypes = {
};
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, {
})(AuthenticationLayoutUkoHalfBeMyself);

const useStyles = makeStyles((theme) => ({
    gridOrderFirst: {
        [theme.breakpoints.up('md')]: {
            order: 1,
        },
        [theme.breakpoints.down('md')]: {
            order: 1,
        },
    },
    gridOrderData: {
        [theme.breakpoints.down('md')]: {
            order: 2,
        },
        [theme.breakpoints.up('md')]: {
            order: 2,
        },
    },
    root: {
        "& .MuiSelect-root": {
            boxShadow: "0px 3px 3px #0000001A",
            borderRadius: "10px",
            opacity: 1,
            margin: 2,
            paddingRight: 0,
        },
        "& .MuiSelect-icon": {
            color: '#EDEDED',
        },
        "& .MuiSelect-root.Mui-selected": {
            border: 'none',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        "&&&:before": {
            borderBottom: "none",
        },
        "&&:after": {
            borderBottom: "none",
        },
    },
    select: {
        '&:hover': {
            backgroundColor: '#3F4849',
            borderRadius: '20px',
            paddingLeft: '5px',
            paddingRight: '5px',
            marginRight: '-5px',
        },
    },
    menuPaper: {
        marginTop: '37px',
        marginLeft: '-38px',
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
        background: '#141D1E',
    },
    menuItem: {
        color: '#BEC8C9',
        '&:hover': {
            color: '#E1FF2B',
        },
        '&.Mui-selected': {
            color: '#E1FF2B',
        },
    },
    version: {
        fontSize: '14px',
        fontWeight: 500,
        color: theme.colorVersionCiamLabel,
        textAlign: 'center',
        width: '92%',
        padding: '16px'
    },
}));